module.exports = __webpack_public_path__ + "img/15.ebd0a3fa.jpg";